import React from 'react';
import CardSurface from '../Card/CardSurface';
import './DashboardStatCard.css';

/** DashboardStatCard — 통계 카드. 사용법: docs/modules/frontend/DashboardStatCard.md
 *  R4c-v2: 헤더 (48×48 아이콘 박스 + title) / value-row (2rem 값 + 단위 + trend) / subtitle. */
const TREND_MARK = {
  up: '▲',
  down: '▼',
  flat: '–',
};

const DashboardStatCard = ({
  title,
  value,
  unit,
  icon,
  subtitle,
  onClick,
  trend,
}) => {
  const isClickable = typeof onClick === 'function';
  const formattedValue =
    typeof value === 'number' ? value.toLocaleString() : value;
  const cardStyle = isClickable ? { cursor: 'pointer' } : undefined;

  return (
    <CardSurface
      data-testid="dashboard-stat-card"
      className="h-100 shadow-sm"
      style={cardStyle}
      onClick={isClickable ? onClick : undefined}
      role={isClickable ? 'button' : undefined}
      tabIndex={isClickable ? 0 : undefined}
    >
      <div className="card-body">
        <div className="dashboard-stat-card__header">
          {icon ? (
            <span
              data-testid="dashboard-stat-card-icon"
              className="dashboard-stat-card__icon"
            >
              {icon}
            </span>
          ) : null}
          <h6 className="dashboard-stat-card__title card-title mb-0">
            {title}
          </h6>
        </div>
        <div className="dashboard-stat-card__value-row">
          <span
            data-testid="dashboard-stat-card-value"
            className="dashboard-stat-card__value"
            style={{ fontSize: '2rem', fontWeight: 700 }}
          >
            {formattedValue}
          </span>
          {unit ? (
            <span className="dashboard-stat-card__unit">{unit}</span>
          ) : null}
          {trend ? (
            <span
              data-testid="stat-trend"
              data-trend={trend}
              className="dashboard-stat-card__trend"
              aria-label={`추세 ${trend}`}
            >
              {TREND_MARK[trend] || ''}
            </span>
          ) : null}
        </div>
        {subtitle ? (
          <div className="dashboard-stat-card__subtitle">{subtitle}</div>
        ) : null}
      </div>
    </CardSurface>
  );
};

export default DashboardStatCard;
